import { render, staticRenderFns } from "./TaskMemoryTab.vue?vue&type=template&id=6a56a06e&scoped=true&"
import script from "./TaskMemoryTab.vue?vue&type=script&lang=js&"
export * from "./TaskMemoryTab.vue?vue&type=script&lang=js&"
import style0 from "./TaskMemoryTab.vue?vue&type=style&index=0&id=6a56a06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a56a06e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
